import script from "./DeptEmps.vue?vue&type=script&setup=true&lang=js"
export * from "./DeptEmps.vue?vue&type=script&setup=true&lang=js"

import "./DeptEmps.vue?vue&type=style&index=0&id=d14f6086&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d14f6086"]])

export default __exports__